/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldGameModuleConfig} from "./MonkeysGoldGameModuleConfig";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {MGWinFieldController} from "./winpresentation/initial/MGWinFieldController";

export class MonkeysGold extends SlotGame {

    constructor() {
        super(MonkeysGoldGameModuleConfig.instance);
    }

    protected createWinFieldController(): WinFieldController {
        return new MGWinFieldController();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L5",
                    "L5",
                    "L1",
                    "L1",
                    "L3",
                    "L3"
                ],
                [
                    "M3",
                    "L2",
                    "L2",
                    "L2",
                    "L4",
                    "L4"
                ],
                [
                    "M1",
                    "M1",
                    "L2",
                    "L5",
                    "M1",
                    "L4"
                ],
                [
                    "L2",
                    "M5",
                    "M4",
                    "L2",
                    "L2",
                    "L5"
                ],
                [
                    "L5",
                    "L5",
                    "L5",
                    "M2",
                    "L3",
                    "M3"
                ],
                [
                    "M3",
                    "M4",
                    "M1",
                    "L4",
                    "M5",
                    "L3"
                ]
            ],
            "evaluatedArea": [
                [
                    "L5",
                    "L5",
                    "L1",
                    "L1",
                    "L3",
                    "L3"
                ],
                [
                    "M3",
                    "L2",
                    "L2",
                    "L2",
                    "L4",
                    "L4"
                ],
                [
                    "M1",
                    "M1",
                    "L2",
                    "L5",
                    "M1",
                    "L4"
                ],
                [
                    "L2",
                    "M5",
                    "M4",
                    "L2",
                    "L2",
                    "L5"
                ],
                [
                    "L5",
                    "L5",
                    "L5",
                    "M2",
                    "L3",
                    "M3"
                ],
                [
                    "M3",
                    "M4",
                    "M1",
                    "L4",
                    "M5",
                    "L3"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "reelsAfterCollapse": [
                [
                    "L5",
                    "L5",
                    "L1",
                    "L1",
                    "L3",
                    "L3"
                ],
                [
                    "M3",
                    "L2",
                    "L2",
                    "L2",
                    "L4",
                    "L4"
                ],
                [
                    "M1",
                    "M1",
                    "L2",
                    "L5",
                    "M1",
                    "L4"
                ],
                [
                    "L2",
                    "M5",
                    "M4",
                    "L2",
                    "L2",
                    "L5"
                ],
                [
                    "L5",
                    "L5",
                    "L5",
                    "M2",
                    "L3",
                    "M3"
                ],
                [
                    "M3",
                    "M4",
                    "M1",
                    "L4",
                    "M5",
                    "L3"
                ]
            ],
            "upgradePositionsAfterCollapse": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "reelsAfterCollapseUpgraded": [
                [
                    "L5",
                    "L5",
                    "L1",
                    "L1",
                    "L3",
                    "L3"
                ],
                [
                    "M3",
                    "L2",
                    "L2",
                    "L2",
                    "L4",
                    "L4"
                ],
                [
                    "M1",
                    "M1",
                    "L2",
                    "L5",
                    "M1",
                    "L4"
                ],
                [
                    "L2",
                    "M5",
                    "M4",
                    "L2",
                    "L2",
                    "L5"
                ],
                [
                    "L5",
                    "L5",
                    "L5",
                    "M2",
                    "L3",
                    "M3"
                ],
                [
                    "M3",
                    "M4",
                    "M1",
                    "L4",
                    "M5",
                    "L3"
                ]
            ],
            "allWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "numberOfScatters": 0,
            "numberOfWaysWon": 0,
            "avalancheCountThisSpinBefore": 0,
            "avalancheCountThisSpinAfter": 0,
            "newSymbols": [],
            "numberOfUpgrades": 0,
            "bigSymbol": false,
            "bigOverlaySymbol": [
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "extraWilds": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "existingBigSymbols": [],
            "bigSymbolsAfterSpin": [],
            "bigSymbolPosition": [
                -1,
                -1
            ],
            "bigSymbolSize": -1,
            "bigSymbolMultiplier": -1,
            "bigSymbolFinalMultiplier": -1,
            "fsMultiplierBefore": 1,
            "fsMultiplierAfter": 1,
            "numberFilledRows": 0,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 73
                }
            ],
            "wasFeatureBuy": false,
            "fsMultiplierIncrease": 0,
            "avalancheSymbolHighlight": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ]
        };
    }

    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#isGreece", "g"), (MonkeysGold.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });
    }

    public getPaytable(): Promise<string> {
        const data = {
            replaceSlotsInGameRules: MonkeysGold.api.gameClientConfiguration.replaceSlotsInGameRules,
            showLowProbabilityGfx: MonkeysGold.api.gameClientConfiguration.jurisdictionName === "US-PA" ? true : MonkeysGold.api.gameClientConfiguration.showLowProbabilityGfx,// added for #353 and #347
            specialImageforUSPA: MonkeysGold.api.gameClientConfiguration.jurisdictionName === "US-PA" ? false : MonkeysGold.api.gameClientConfiguration.showLowProbabilityGfx // added for #354
        };

        return super.getPaytable().then((value: string) => {
            return MonkeysGold.api.translations.render(value, data);
        });
    }
}